import { take, put, call, fork, select, takeEvery, all } from 'redux-saga/effects';
import * as sagaController from '../../../../controllers/sagaController';
import * as types from '../../../../system/types';
import * as R from 'ramda';
import * as actions from './actions';
import * as rootActions from '../../../../system/actions';
import { ArchivoResultadoCotizadorAP, ResultadoCotizadorAP } from '../../../../api/Clients';
import { IResponse } from '../../../../models/IResponse';
import { AxiosResponse } from 'axios';
import { IResultadoCotizadorAPResponse } from '../../../../models/cotizador/IResultadoCotizadorAPResponse';
import { IExportarArchivoResponse } from '../../../../models/IExportarArchivoResponse';

//#region RESULTADO COTIZADOR AP
export function* resultadoCotizadorAPRequestAsync(action: types.requestResultadoCotizadorAPAction) {
    const response: IResultadoCotizadorAPResponse = yield call(ResultadoCotizadorAP, action.data);
    // console.log(response);
    try {
        const {
            data,
            code,
            status,
            statusText,
            // headers,
            // config,
            // request,
        } = response;
        if (!R.isNil(data)) {
            yield sagaController.controlledStates(response, action.type, status);
        } else {
            yield sagaController.controlledStates(response, action.type, 400);
        }
    } catch (error) {
        console.log(error);
    }
}

export function* resultadoCotizadorAPSaga() {
    yield all([
        takeEvery(types.RESULTADOCOTIZADORAP_REQUEST, resultadoCotizadorAPRequestAsync)
    ])
}
//#endregion

//#region ARCHIVO RESULTADO COTIZADOR AP
export function* archivoResultadoCotizadorAPRequestAsync(action: types.requestArchivoResultadoCotizadorAPAction) {
    const response: IExportarArchivoResponse = yield call(ArchivoResultadoCotizadorAP, action.data);
    // console.log(response);
    try {
        const {
            data,
            code,
            status,
            statusText,
            // headers,
            // config,
            // request,
        } = response;
        if (!R.isNil(data)) {
            yield sagaController.controlledStates(response, action.type, status);
        } else {
            yield sagaController.controlledStates(response, action.type, 400);
        }
    } catch (error) {
        console.log(error);
    }
}

export function* archivoResultadoCotizadorAPSaga() {
    yield all([
        takeEvery(types.ARCHIVORESULTADOCOTIZADORAP_REQUEST, archivoResultadoCotizadorAPRequestAsync)
    ])
}
//#endregion